'use strict';
import classNames from 'classnames';
import * as T from 'prop-types';
import React, {Fragment} from 'react';
import {Button} from '../../../components/buttons/Button';
import {ProjectLayout} from '../../../components/views/ProjectLayout';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {I18nComponent} from '../../../core-utilities/react-i18n';
import {AssetProjectCard} from '../../../projects/components/AssetProjectCard';
import {AssetProjectCardList} from '../../../projects/components/AssetProjectCardList';
import {AssetViewBanner} from '../AssetViewBanner';
import {AssetViewOverviewFilter} from './AssetViewOverviewFilter';


export function BaseAssetViewOverviewView(props) {
  return (
    <ProjectLayout
      className={classNames("AssetViewOverview", props.className)}
      title={props.viewTitle}
      breadcrumbPath={props.breadcrumbPath}
      filterComponent={<AssetViewOverviewFilter parentId={props.parentId} />}
      headerRightContent={(
        <Fragment>
          <Button
            className="ProjectViewTasks__headerButton"
            activeClassName="ProjectViewTasks__headerButton_active"
            iconClass="context-icon"
            onClick={props.onClickOptions}
          />
        </Fragment>
      )}
      navBarContent={null}
      bannerContent={(
        <AssetViewBanner
          userId={props.userId}
          asset={props.asset}
          onClickEdit={props.onClickEdit}

          init={props.init}
        />
      )}
      mode={props.mode}
      onLoadMore={props.onLoadMore}
    >
      <Fragment>
        {props.assetProject ? (
          <Fragment>
            <span className="AssetViewOverview__projects">
              {props.projectSelectedLabel}
            </span>
            <div className="AssetProjectCardList__container">
              <AssetProjectCard
                key={getId(props.assetProject)}
                className="AssetProjectCardList__card"
                model={props.assetProject}
                onClick={props.onClickItem}
              />
            </div>
          </Fragment>
        ) : null}
        <span
          className={classNames("AssetViewOverview__projects", {
            AssetViewOverview__projects__second: props.assetProject,
          })}
        >
          {props.navBannerDescriptionLabel}
        </span>
        <AssetProjectCardList
          className="AppNavigationProjects__list"
          useScroll={false}
          userId={props.userId}
          list={props.list}
          mode={props.mode}
          hasMore={props.hasMore}
          onClickItem={props.onClickItem}
          filterId={getId(props.assetProject)}

          init={props.init}
        />
      </Fragment>
    </ProjectLayout>
  );
}

BaseAssetViewOverviewView.propTypes = {
  className: T.string,
  asset: T.object,
  assetProject: T.object,

  projectSelectedLabel: T.string,
  navBannerDescriptionLabel: T.string,
  init: T.bool,
};

BaseAssetViewOverviewView.defaultProps = {
  init: true,
};

export const AssetViewOverviewView = I18nComponent(BaseAssetViewOverviewView, [
  {code: 'assets.home.header.label', prop: 'viewTitle'},
  {code: 'assets.projects.nav.banner.project.selected', prop: 'projectSelectedLabel'},
  {code: 'assets.projects.nav.banner.description', prop: 'navBannerDescriptionLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/assets/components/AssetViewOverview/AssetViewOverviewView.js